import { Link as RouterLink } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { PageHero, Section } from "../components/ui";
import { tokens } from "../theme";

// About, Gift, Employers, Privacy and Terms share this placeholder layout.
export default function Simple({ eyebrow, title, subtitle, body, cta }) {
  return (
    <>
      <PageHero eyebrow={eyebrow} title={title} subtitle={subtitle} />
      <Section tone="white" narrow>
        {body.map((p, i) => <Typography key={i} sx={{ color: tokens.muted, fontSize: 18, mb: 2.5 }}>{p}</Typography>)}
        {cta && <Button variant="contained" component={RouterLink} to={cta.to} sx={{ mt: 2 }}>{cta.label}</Button>}
      </Section>
    </>
  );
}
